import { useAuth0 } from "@auth0/auth0-react";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemText,
  Avatar,
  Divider,
  Box,
} from "@mui/material";
import { useState } from "react";
import { Link, useNavigate } from "react-router";

import LogoutButton from "@/components/Navbar/NavbarComponents/LogoutButton";
import { useNavLinks } from "@/components/Navbar/useNavLinks";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext";
import { canChangeWorkflow } from "@/utils/permissionsHandler";

export default function NavBarDropdown() {
  const { user } = useAuth0();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [subMenuAnchorEl, setSubMenuAnchorEl] = useState(null);
  const subMenuOpen = Boolean(subMenuAnchorEl);
  const { resetContext, handleWorkflowChange } = useUpdateDataContext();
  const navigate = useNavigate();
  const userLinks = useNavLinks(user);

  const handleMainMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMainMenuClose = () => {
    setAnchorEl(null);
    setSubMenuAnchorEl(null); // close submenu when main menu closes
  };

  const handleSubMenuClick = (event) => {
    setSubMenuAnchorEl(event.currentTarget);
  };

  const handleSubMenuClose = () => {
    setSubMenuAnchorEl(null);
  };

  const changeWorkflow = (workflow) => {
    handleWorkflowChange(workflow);
    resetContext();

    if (workflow === "political") {
      navigate("/political/update-data/select-file");
    } else {
      navigate("/membership/dashboard");
    }
    handleMainMenuClose();
  };

  return (
    <div>
      <IconButton
        className="navbar-element"
        onClick={handleMainMenuClick}
        data-testid="dropdown-menu-icon"
      >
        <Avatar sx={{ color: "white", fontSize: "2rem" }} />
      </IconButton>

      {/* --- Main Menu --- */}
      <Menu anchorEl={anchorEl} open={open} onClose={handleMainMenuClose}>
        <Box>
          {userLinks &&
            userLinks.horizontalLinks.map((link) => (
              <MenuItem
                key={link.name}
                component={Link}
                to={link.url}
                // only show if screen is smaller than medium
                sx={{ display: { sm: "block", md: "none" } }}
                onClick={handleMainMenuClose}
              >
                {link.name}
              </MenuItem>
            ))}
          {userLinks &&
            userLinks.verticalLinks.map((link) => (
              <MenuItem
                key={link.name}
                component={Link}
                to={link.url}
                onClick={handleMainMenuClose}
              >
                {link.name}
              </MenuItem>
            ))}
        </Box>

        {/* --- Parent MenuItem for the workflow submenu --- */}
        {canChangeWorkflow(user) && (
          <MenuItem
            onClick={handleSubMenuClick} // Open the submenu on click
            // Prevent the main menu from closing when you click this item
            onClose={(e) => e.stopPropagation()}
          >
            <ListItemText>Change Workflow</ListItemText>
            <ArrowRightIcon />
          </MenuItem>
        )}

        {userLinks.verticalLinks.length > 1 && <Divider />}
        <MenuItem>
          <LogoutButton />
        </MenuItem>
      </Menu>

      {/* --- Workflow Options --- */}
      <Menu
        anchorEl={subMenuAnchorEl}
        open={subMenuOpen}
        onClose={handleSubMenuClose}
        // Reposition the submenu to the right edge of its parent MenuItem
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem onClick={() => changeWorkflow("membership")}>
          Membership Data
        </MenuItem>
        <MenuItem onClick={() => changeWorkflow("political")}>
          Volunteer Data
        </MenuItem>
      </Menu>
    </div>
  );
}
